module.exports = __webpack_public_path__ + "src/img/localUpload.77a9a665.svg";